type CoordinateValidationResult = {
    isValid: boolean;
    error: string | null;
};

export const validateCoordinates = (
    lat: number,
    lng: number
): CoordinateValidationResult => {
    
    if (lat === undefined || lat === null) {
        return {
            isValid: false,
            error: "Latitude is missing.",
        };
    }

    if (lng === undefined || lng === null) {
        return {
            isValid: false,
            error: "Longitude is missing.",
        };
    }

    // 🔹 Check type
    if (typeof lat !== "number" || isNaN(lat)) {
        return {
            isValid: false,
            error: "Latitude must be a valid number.",
        };
    }

    if (typeof lng !== "number" || isNaN(lng)) {
        return {
            isValid: false,
            error: "Longitude must be a valid number.",
        };
    }

    return {
        isValid: true,
        error: null,
    };
};